import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/img/refresh_white.svg'


const _hoisted_1 = { class: "page_header" }
const _hoisted_2 = {
  key: 0,
  class: "formContainer"
}
const _hoisted_3 = {
  width: "180",
  filter: "createdOn",
  sort: "createdOn",
  filterType: "date"
}
const _hoisted_4 = {
  width: "600",
  filter: "companyName",
  sort: "companyName"
}
const _hoisted_5 = {
  width: "150",
  filter: "loginFromDomain",
  sort: "loginFromDomain",
  filterType: "checkbox"
}
const _hoisted_6 = {
  width: "150",
  filter: "domain",
  sort: "domain"
}
const _hoisted_7 = {
  width: "150",
  filter: "apikey",
  sort: "apikey"
}
const _hoisted_8 = {
  filter: "licenses.length",
  sort: "licenses.length"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { colspan: "10" }
const _hoisted_12 = { class: "d-flex align-items-center justify-content-center" }
const _hoisted_13 = { class: "me-2" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "text-end" }
const _hoisted_18 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_19 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_localized_text, {
        type: 'h1',
        localizedKey: "Companies",
        text: "Companies",
        class: "mb-0"
      }),
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editCompany(null)))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Add Company",
          text: "Add Company"
        })
      ])
    ]),
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_op_table, {
            class: "table table-striped",
            items: _ctx.items
          }, {
            default: _withCtx((opData) => [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_3, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Created on",
                      text: "Created on"
                    })
                  ]),
                  _createElementVNode("td", _hoisted_4, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Name",
                      text: "Name"
                    })
                  ]),
                  _createElementVNode("td", _hoisted_5, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Login from domain",
                      text: "Login from domain"
                    })
                  ]),
                  _createElementVNode("td", _hoisted_6, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Domain",
                      text: "Domain"
                    })
                  ]),
                  _createElementVNode("td", _hoisted_7, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "API KEY",
                      text: "API KEY"
                    })
                  ]),
                  _createElementVNode("td", _hoisted_8, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Active licenses",
                      text: "Active licenses"
                    })
                  ]),
                  _hoisted_9
                ])
              ]),
              _createElementVNode("tbody", null, [
                (opData.data.length == 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                      _createElementVNode("td", _hoisted_11, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "No Elements Found",
                          text: "No Elements Found"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((opData.data as OM.Company[]), (item, i) => {
                  return (_openBlock(), _createElementBlock("tr", { key: i }, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.$filters.date(item.createdOn)), 1),
                    _createElementVNode("td", null, _toDisplayString(item.companyName), 1),
                    _createElementVNode("td", null, [
                      (item.loginFromDomain)
                        ? (_openBlock(), _createBlock(_component_localized_text, {
                            key: 0,
                            localizedKey: "Yes",
                            text: "Yes"
                          }))
                        : (_openBlock(), _createBlock(_component_localized_text, {
                            key: 1,
                            localizedKey: "No",
                            text: "No"
                          }))
                    ]),
                    _createElementVNode("td", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.domains, (domain) => {
                        return (_openBlock(), _createElementBlock("span", {
                          class: "d-block mb-1",
                          key: domain
                        }, _toDisplayString(domain), 1))
                      }), 128))
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("span", _hoisted_13, _toDisplayString(item.apikey), 1),
                        _createElementVNode("button", {
                          class: "btn btn-primary squareButton",
                          onClick: ($event: any) => (_ctx.resetApiKey(item))
                        }, _hoisted_16, 8, _hoisted_14)
                      ])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.licenses.length), 1),
                    _createElementVNode("td", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("button", {
                          class: "btn btn-primary m-1",
                          onClick: ($event: any) => (_ctx.editCompany(item))
                        }, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Edit",
                            text: "Edit"
                          })
                        ], 8, _hoisted_19),
                        _createVNode(_component_router_link, {
                          class: "btn btn-secondary m-1",
                          to: '/companies/' + item.identifier + '/users'
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_localized_text, {
                              localizedKey: "Users",
                              text: "Users"
                            })
                          ]),
                          _: 2
                        }, 1032, ["to"]),
                        _createVNode(_component_router_link, {
                          class: "btn btn-tertiary ms-1",
                          to: '/companies/' + item.identifier + '/materials'
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_localized_text, {
                              localizedKey: "Materials",
                              text: "Materials"
                            })
                          ]),
                          _: 2
                        }, 1032, ["to"]),
                        _createVNode(_component_router_link, {
                          class: "btn btn-secondary m-1",
                          to: '/companies/' + item.identifier + '/licenses'
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_localized_text, {
                              localizedKey: "Licenses",
                              text: "Licenses"
                            })
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["items"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}